export const extractRoundNumber = (
  data: Sentinel.NegExecution.Response | undefined
): string | null => {
  if (!data?.length) return null;

  const roundPattern = /Rodada\s*(\d+)/i;

  for (const item of data) {
    const match = roundPattern.exec(item.message);

    if (match) return match[1];
  }

  return null;
};
